import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const PrimengTheme = definePreset( Aura, {
    semantic: {
        primary: {
            '50': 'var(--primary-50)',
            '100': 'var(--primary-100)',
            '200': 'var(--primary-200)',
            '300': 'var(--primary-300)',
            '400': 'var(--primary-400)',
            '500': 'var(--primary-500)',
            '600': 'var(--primary-600)',
            '700': 'var(--primary-700)',
            '800': 'var(--primary-800)',
            '900': 'var(--primary-900)',
            '950': 'var(--primary-950)'
        }
    },
    components: {
        checkbox: { root: { width: '20px', height: '20px', borderRadius: '0px' } },
        button: { root: { borderRadius: '0px' } },
        radiobutton: { root: { width: '20px', height: '20px' } },
        inputtext: {
            root: {
                borderRadius: '0px',
                disabledBackground: 'var(--p-inputtext-background)',
                disabledColor: 'var(--p-inputtext-color)'
            }
        },
        select: { root: { borderRadius: '0px' } },
        dialog: {
            root: { borderRadius: '0px' },
            css: () => `
                .p-dialog-content {
                    flex-grow: 1;
                }

                .p-dialog-header-actions .p-dialog-close-button{
                    color: #a0a0a0 !important;
                }
                
                .p-dialog-header-actions .p-dialog-close-button:hover{
                    color: #1b2735 !important;
                    background: #edf1f2 !important;
                }
            `
        },
        multiselect: {
            css: () => `
                .p-multiselect{
                  border-radius:0;
                  border:1px solid #dcdcdc !important;
                  box-shadow:none !important;
                }
                
                .p-multiselect:not(.p-disabled):hover{
                  border-color:#4d777c !important;
                }
                
                .p-multiselect:focus-within,
                .p-multiselect.p-focus{
                  outline:0 !important;
                  box-shadow:none !important;
                  border-color:#4d777c !important;
                }
                
                .p-multiselect .p-multiselect-label{
                  border-radius:0;
                  background:var(--primary-500) !important;
                  color:#fff !important;
                }
                
                .p-multiselect .p-multiselect-trigger,
                .p-multiselect .p-multiselect-dropdown{
                  padding:0;
                  border:0 !important;
                  border-radius:0;
                  background:var(--primary-500) !important;
                  color:#fff !important;
                }
                
                .p-multiselect .p-multiselect-trigger,
                .p-multiselect .p-multiselect-dropdown{
                  --p-button-bg: var(--primary-500);
                  --p-button-hover-bg: var(--primary-500);
                  --p-button-active-bg: var(--primary-500);
                  --p-button-text-color: #fff;
                }
                
                .p-multiselect .p-multiselect-trigger:hover,
                .p-multiselect .p-multiselect-dropdown:hover{
                  background:var(--primary-500) !important;
                  color:#fff !important;
                }
                
                .p-multiselect .p-multiselect-trigger:focus,
                .p-multiselect .p-multiselect-trigger:focus-visible,
                .p-multiselect .p-multiselect-dropdown:focus,
                .p-multiselect .p-multiselect-dropdown:focus-visible{
                  outline:0;
                  box-shadow:none !important;
                }
                
                .p-multiselect .p-multiselect-trigger .p-icon,
                .p-multiselect .p-multiselect-dropdown .p-icon{
                  color:#fff !important;
                }
                
                .p-multiselect .p-multiselect-trigger svg,
                .p-multiselect .p-multiselect-dropdown svg{
                  fill:currentColor !important;
                  stroke:currentColor !important;
                  color:#fff !important;
                }
                
                .p-multiselect-panel.app-multi-select-panel{
                  border-radius:8px;
                  padding:10px;
                  border:1px solid #D9DADB;
                  box-shadow:0 4px 20px rgba(0,0,0,.08);
                  background:#fff;
                  margin:8px;
                }
                
                .p-multiselect-panel.app-multi-select-panel .p-multiselect-items{
                  padding:6px;
                }
                
                .p-multiselect-panel.app-multi-select-panel .p-multiselect-item{
                  border-radius:6px;
                  margin:2px 0;
                  background:transparent;
                  color:#1B1B1C;
                }
                
                .p-multiselect-panel.app-multi-select-panel .p-multiselect-item:hover{
                  background:#f5f7f9;
                }
                
                .p-multiselect-panel.app-multi-select-panel .p-multiselect-item.p-highlight,
                .p-multiselect-panel.app-multi-select-panel .p-multiselect-item.p-highlight.p-focus{
                  background:transparent !important;
                  color:#1B1B1C !important;
                }
                
                .p-multiselect-panel.app-multi-select-panel .p-checkbox .p-checkbox-box{
                  border-radius:6px;
                  border-color:#C5C7CD;
                }
                
                .p-multiselect-panel.app-multi-select-panel .p-multiselect-item.p-highlight .p-checkbox-box,
                .p-multiselect-panel.app-multi-select-panel .p-multiselect-item.p-highlight.p-focus .p-checkbox-box{
                  background:var(--primary-500) !important;
                  border-color:var(--primary-500) !important;
                }
                
                .p-multiselect-panel.app-multi-select-panel .p-checkbox-box .p-checkbox-icon,
                .p-multiselect-panel.app-multi-select-panel .p-checkbox-box svg{
                  color:#fff !important;
                  fill:#fff !important;
                  stroke:#fff !important;
                }
                `
        },

        autocomplete: {
            css: () => `
                .p-autocomplete{width:100%}
                
                .p-autocomplete .p-autocomplete-input{
                  width:100%;
                  border-radius:0;
                }
                
                .p-autocomplete.p-focus .p-autocomplete-input,
                .p-autocomplete .p-autocomplete-input:focus{
                  border-color:var(--primary-500) !important;
                  box-shadow:0 0 0 2px color-mix(in srgb, var(--primary-500) 25%, transparent) !important;
                  outline:none !important;
                }
                
                .p-autocomplete .p-autocomplete-dropdown{
                  width:32px;
                  min-width:32px;
                  height:32px;
                  padding:0;
                  border-radius:0 !important;
                  border:1px solid var(--surface-border);
                  background:var(--primary-500) !important;
                  color:#fff !important;
                  --p-button-bg: var(--primary-500);
                  --p-button-hover-bg: var(--primary-500);
                  --p-button-active-bg: var(--primary-500);
                  --p-button-text-color: #fff;
                }

                .p-autocomplete.p-focus .p-autocomplete-dropdown{
                  border-color:var(--primary-500) !important;
                }

                .p-autocomplete .p-autocomplete-dropdown:hover{
                  background:var(--primary-500) !important;
                  color:#fff !important;
                  filter:brightness(.95);
                }

                .p-autocomplete .p-autocomplete-dropdown:focus,
                .p-autocomplete .p-autocomplete-dropdown:focus-visible{
                  outline:0;
                  box-shadow:none !important;
                }

                .p-autocomplete .p-autocomplete-dropdown .p-icon{
                  color:#fff !important;
                }

                .p-autocomplete .p-autocomplete-dropdown svg{
                  fill:currentColor !important;
                  stroke:currentColor !important;
                  color:#fff !important;
                }
                
                .p-autocomplete-panel{
                  z-index:9999 !important;
                  background:#fff;
                  border:1px solid var(--surface-border);
                  border-radius:0;
                  box-shadow:0 6px 18px rgba(0,0,0,.12);
                  margin-top:2px;
                  overflow:auto;
                }
                
                .p-autocomplete-panel .p-autocomplete-items{
                  padding:0;
                }
                
                .p-autocomplete-panel .p-autocomplete-item{
                  padding:10px 12px;
                  font-size:13px;
                  line-height:1.2;
                  white-space:nowrap;
                  border-radius:0;
                }
                
                .p-autocomplete-panel .p-autocomplete-item:not(:last-child){
                  border-bottom:1px solid var(--surface-border);
                }
                
                .p-autocomplete-panel .p-autocomplete-item:hover{
                  background:var(--surface-hover);
                }
                
                .p-autocomplete-panel .p-autocomplete-item.p-highlight{
                  background:var(--primary-50);
                  color:var(--text-color);
                }
                `
        },

        inputgroup: {
            css: () => `
                .p-inputgroup,
                .p-inputgroup > *,
                .p-inputgroup-addon,
                .p-inputgroup > .p-inputgroup-addon:first-child,
                .p-inputgroup > .p-inputgroup-addon:last-child,
                .p-inputgroup > *:first-child,
                .p-inputgroup > *:last-child{
                  border-radius:0 !important;
                }
                `
        },

        accordion: {
            root: { transitionDuration: '0.2s' },
            panel: { borderWidth: '1px' },
            header: {
                padding: '1.7rem',
                color: 'var(--text-color)',
                hoverColor: 'var(--text-color)',
                activeColor: 'var(--text-color)',
                fontWeight: '700',
                background: 'var(--surface-c)',
                hoverBackground: 'var(--surface-c)',
                activeBackground: 'var(--surface-c)',
                activeHoverBackground: 'var(--surface-c)'
            },
            css: () => `
                .p-accordion .p-accordionpanel{
                  border-radius:12px;
                  overflow:hidden;
                }
                .p-accordion .p-accordionpanel:last-child{
                  margin-bottom:1rem;
                }
                .p-accordion .p-accordionheader{
                  font-size:18px;
                }
                .p-accordion .p-accordioncontent{
                  border-bottom-left-radius:12px;
                  border-bottom-right-radius:12px;
                }
                `
        },

        datepicker: {
            css: () => `
                .p-datepicker .p-datepicker-input{border-right:0;width:100%}
                
                .p-datepicker .p-datepicker-dropdown,
                .p-datepicker-dropdown{
                  width:28px;
                  min-width:28px;
                  height:28px;
                  padding:0;
                  border-radius:0 !important;
                }

                .p-datepicker .p-datepicker-dropdown{
                  border:1px solid var(--primary-300);
                  background:var(--primary-500);
                  color:#fff;
                }
                
                .p-datepicker .p-datepicker-dropdown:hover{
                  background:var(--primary-800);
                  border-color:var(--primary-800);
                }
                
                .p-datepicker .p-datepicker-dropdown .p-icon{
                  color:#fff;
                }
                `
        },

        datatable: {
          sortIcon: {
              size: '14px',
          },
          headerCell: {
              hoverBackground: '#e9ecef',
          },
          css: () => `
            .p-datatable .p-datatable-sortable-column .p-datatable-sort-icon {
                margin-left:0.5rem;
            }

            .p-datatable .p-datatable-thead > tr > th.p-datatable-column-sorted {
                background: #f8f9fa;
            }

            .p-datatable .p-datatable-thead > tr > th.p-datatable-column-sorted:hover {
                background: var(--p-datatable-header-cell-hover-background);
            }
          `
        },

        inputnumber: {
            css: () => `
                .p-inputnumber .p-inputnumber-button{
                  background-color:var(--primary) !important;
                  border-radius:0 !important;
                  color:#fff !important;
                }
                .p-inputnumber .p-inputnumber-button:hover{
                  background-color:var(--primary-600) !important;
                }
                
                .p-inputnumber .p-inputnumber-button:disabled,
                .p-inputnumber .p-inputnumber-button[disabled]{
                  opacity: 0.6 !important;
                  cursor: not-allowed !important;
                  pointer-events: none !important;
                }
                
                .p-inputnumber .p-inputnumber-button:disabled:hover,
                .p-inputnumber .p-inputnumber-button[disabled]:hover{
                  opacity: 0.6 !important;
                }
                `
        },

        tieredmenu: {
          css: () => `
            .p-tieredmenu.p-tieredmenu-overlay {
              padding-top: 0;
              padding-bottom: 0;
              min-width: 0px !important;
            }

            .p-tieredmenu.p-tieredmenu-overlay .p-tieredmenu-root-list {
              padding: 0;
            }

            .p-tieredmenu.p-tieredmenu-overlay .p-tieredmenu-item-link {
              padding-top: 9px;
              padding-bottom: 9px;
            }

            .p-tieredmenu.p-tieredmenu-overlay .p-tieredmenu-item-link:hover {
              text-decoration: none;
              background-color: #365357;
            }

            .p-tieredmenu.p-tieredmenu-overlay .p-tieredmenu-item-link:hover span {
              color: #fafafa;
            }
          `
        },

        toast: {
            summary: { fontWeight: '700', fontSize: '1rem' },
            detail: { fontWeight: '500', fontSize: '1rem' },
            icon: { size: '1.5rem' },
            content: { padding: '1rem' },
            colorScheme: {
                light: {
                    error: {
                        background: '#ffeae8',
                        borderColor: '#e00101',
                        color: '#e00101',
                        detailColor: '#e00101',
                    },
                    success: {
                        background: '#e5f5e8',
                        borderColor: '#009c3e',
                        color: '#009c3e',
                        detailColor: '#009c3e',
                    },
                    warn: {
                        background: '#ffeedf',
                        borderColor: '#d07122',
                        color: '#d07122',
                        detailColor: '#d07122',
                    },
                    info: {
                        background: '#e4f5f5',
                        borderColor: '#7acdcb',
                        color: '#7acdcb',
                        detailColor: '#7acdcb',
                    },
                },
            },
            css: () => `
                .p-toast .p-toast-message {
                  margin: 0 0 1rem 0;
                  box-shadow: 0 3px 14px 0 rgba(0, 0, 0, 0.3);
                  border-radius: 0;
                  border-width: 0 0 0 4px;
                }

                .p-toast .p-toast-message .p-toast-message-content .p-toast-summary {
                  font-weight: 700;
                }

                .p-toast .p-toast-message .p-toast-message-content .p-toast-detail {
                  margin: 0.5rem 0 0 0;
                }

                .p-toast .p-toast-close-button,
                .p-toast .p-toast-icon-close {
                  display: block !important;
                  opacity: 1 !important;
                  right: 0.5rem !important;
                  top: 0.5rem !important;
                  /* PrimeNG's default .p-toast-close-button sets margin: -25% 0 0 0
                     (~-73.5px), which pushes the button up out of the toast. */
                  margin: 0 !important;
                  position: absolute !important;
                  z-index: 10;
                }

                .custom-toast .p-toast-detail,
                .custom-toast .p-toast-message-text {
                  white-space: pre-wrap;
                  word-break: break-word;
                  overflow-wrap: break-word;
                }

                .custom-toast {
                  border-radius: 10px !important;
                  border-width: 0 0 0 6px !important;
                  white-space: pre-line;
                  position: relative;
                }

                .custom-error-toast {
                  background: #ffeae8 !important;
                  border-color: #e00101 !important;
                  color: #e00101 !important;
                }

                .custom-error-toast .p-toast-summary,
                .custom-error-toast .p-toast-detail,
                .custom-error-toast .p-toast-message-icon,
                .custom-error-toast .p-toast-close-button,
                .custom-error-toast .p-toast-icon-close {
                  color: #e00101 !important;
                }

                .custom-success-toast {
                  background: #e5f5e8 !important;
                  border-color: #009c3e !important;
                  color: #009c3e !important;
                }

                .custom-success-toast .p-toast-summary,
                .custom-success-toast .p-toast-detail,
                .custom-success-toast .p-toast-message-icon,
                .custom-success-toast .p-toast-close-button,
                .custom-success-toast .p-toast-icon-close {
                  color: #009c3e !important;
                }

                .custom-warn-toast {
                  background: #ffeedf !important;
                  border-color: #d07122 !important;
                  color: #d07122 !important;
                }

                .custom-warn-toast .p-toast-summary,
                .custom-warn-toast .p-toast-detail,
                .custom-warn-toast .p-toast-message-icon,
                .custom-warn-toast .p-toast-close-button,
                .custom-warn-toast .p-toast-icon-close {
                  color: #d07122 !important;
                }

                .custom-info-toast {
                  background: #e4f5f5 !important;
                  border-color: #7acdcb !important;
                  color: #7acdcb !important;
                }

                .custom-info-toast .p-toast-summary,
                .custom-info-toast .p-toast-detail,
                .custom-info-toast .p-toast-message-icon,
                .custom-info-toast .p-toast-close-button,
                .custom-info-toast .p-toast-icon-close {
                  color: #7acdcb !important;
                }
                `
        }
    }
} );